export default __webpack_public_path__ + "static/media/rou.c7d9f081.gif";